"use strict";

require("core-js/modules/es.array.filter");
require("core-js/modules/es.object.assign");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileOwnerModel = void 0;
var ProfileOwnerModel = /*#__PURE__*/function () {
  function ProfileOwnerModel(profileOwner) {
    this.phone = void 0;
    this.isStub = void 0;
    this.firstName = void 0;
    this.lastName = void 0;
    this.middleName = void 0;
    this.fullName = void 0;
    this.email = void 0;
    this.individualInn = void 0;
    this.organizationInn = void 0;
    var lastName = profileOwner.lastName,
      firstName = profileOwner.firstName,
      middleName = profileOwner.middleName;
    var fullName = this._getFullName(lastName, firstName, middleName);
    Object.assign(this, profileOwner, {
      isStub: false
    }, fullName && {
      fullName
    });
  }

  /** Заглушка на случай, если API вернёт пустой объект, ошибку и т.п. */
  ProfileOwnerModel.Stub = function Stub() {
    return Object.assign({}, new ProfileOwnerModel({
      phone: ''
    }), {
      isStub: true
    });
  };
  var _proto = ProfileOwnerModel.prototype;
  _proto._getFullName = function _getFullName(lastName, firstName, middleName) {
    return [lastName, firstName, middleName].filter(Boolean).join(' ');
  };
  return ProfileOwnerModel;
}();
exports.ProfileOwnerModel = ProfileOwnerModel;